import React from 'react'
import { useNavigation } from '@react-navigation/native'
import pluralize from 'pluralize'
import { TouchableOpacity, View } from 'react-native'
import { Feature, useFeatureFlag } from '@components/FeatureFlag'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon, Text } from '@src/components/base'
import { useCoachingCallAllowanceBalance } from '@src/hooks/useCoachingCallAllowanceBalance'
import { NextCallCard, NextCallCardProps } from './NextCallCard'

export const NextCallSection = (props: NextCallCardProps) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()
  const videoCallCreditsEnabled = useFeatureFlag(Feature.VideoCallCredits)
  const { availableCredits, hasAllowanceBalance } = useCoachingCallAllowanceBalance()
  const showCreditBadge = videoCallCreditsEnabled && hasAllowanceBalance
  useLazyScreenPreload('CoachingCallCreditBalanceModal', { shouldPreload: showCreditBadge })

  const onCreditBadgePress = () => {
    navigation.navigate('CoachingCallCreditBalanceModal')
  }

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.headerContent}>
          <Icon name="video-camera" />
          <View style={styles.headerText}>
            <Text type="regular" bold>
              Next Call
            </Text>
          </View>
        </View>
        {showCreditBadge && (
          <TouchableOpacity
            activeOpacity={0.8}
            accessibilityRole="button"
            accessibilityLabel="Open coaching call credits"
            style={styles.creditBadge}
            onPress={onCreditBadgePress}
          >
            <Icon name="coin" size={18} weight="bold" style={styles.creditBadgeSurface} />
            <Text type="small" bold style={styles.creditBadgeSurface}>
              {availableCredits} {pluralize('Credit', availableCredits)} Left
            </Text>
          </TouchableOpacity>
        )}
      </View>

      <NextCallCard {...props} />
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    gap: 16,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    marginLeft: 8,
    lineHeight: 24,
    flexDirection: 'column',
  },
  creditBadge: {
    height: 32,
    borderRadius: 32,
    borderWidth: 1,
    borderColor: 'theme.surface.base0',
    backgroundColor: 'theme.surface.base2',
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  creditBadgeSurface: {
    color: 'theme.text.secondary',
  },
})
